import { CalendarSurfaceItemContentProps } from './CalendarSurfaceItem.types';
import { renderCharmWrapper, renderIconWrapper } from '../CalendarSurfaceItemComponentRenderer';
import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import { noSubject } from 'owa-locstrings/lib/strings/nosubject.locstring.json';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('../CalendarSurfaceItem.scss');

/**
 * The Component for a Calendar Surface item under 45 minutes long
 */
const CalendarSurfaceItemUnder45 = observer(function CalendarSurfaceItemUnder45(
    props: CalendarSurfaceItemContentProps
) {
    const { item, colorScheme, charmId, allowEmptySubject } = props;
    const contentClasses = classNames(
        styles.itemContent,
        styles.calendarItemClippingLine,
        styles.singleLineItem
    );

    let subject = item.Subject;
    if (!subject && !allowEmptySubject) {
        subject = loc(noSubject);
    }
    const location = item.Location && item.Location.DisplayName;
    const organizer = item.Organizer && item.Organizer.Mailbox.Name;

    return (
        <>
            <div className={contentClasses}>
                <h2 className={classNames(styles.itemSubject, styles.truncatedSubject)}>
                    {renderCharmWrapper(item, colorScheme, charmId)}
                    <span>{subject}</span>
                </h2>
                {location && (
                    <span className={classNames(styles.locationWrapper, styles.itemElementContent)}>
                        {location}
                    </span>
                )}
                {item.IsMeeting && organizer && (
                    <span className={classNames(styles.locationWrapper, styles.itemElementContent)}>
                        {organizer}
                    </span>
                )}
            </div>
            {renderIconWrapper(item, true)}
        </>
    );
});
export default CalendarSurfaceItemUnder45;
